var _excluded = ["globalFilter"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { getFilterMethod, shouldAutoRemoveFilter, getFirstDefined } from '../utils';
import { actions, useMountedLayoutEffect, functionalUpdate, useGetLatest } from '../publicUtils';
import * as filterTypes from '../filterTypes'; // Actions

actions.resetGlobalFilter = 'resetGlobalFilter';
actions.setGlobalFilter = 'setGlobalFilter';
export var useGlobalFilter = function useGlobalFilter(hooks) {
  hooks.stateReducers.push(reducer);
  hooks.useInstance.push(useInstance);
};
useGlobalFilter.pluginName = 'useGlobalFilter';

function reducer(state, action, previousState, instance) {
  if (action.type === actions.resetGlobalFilter) {
    return _objectSpread(_objectSpread({}, state), {}, {
      globalFilter: instance.initialState.globalFilter || undefined
    });
  }

  if (action.type === actions.setGlobalFilter) {
    var filterValue = action.filterValue;
    var userFilterTypes = instance.userFilterTypes;
    var filterMethod = getFilterMethod(instance.globalFilter, userFilterTypes || {}, filterTypes);
    var newFilter = functionalUpdate(filterValue, state.globalFilter); //

    if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter)) {
      var globalFilter = state.globalFilter,
          stateWithoutGlobalFilter = _objectWithoutProperties(state, _excluded);

      return stateWithoutGlobalFilter;
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      globalFilter: newFilter
    });
  }
}

function useInstance(instance) {
  var data = instance.data,
      rows = instance.rows,
      flatRows = instance.flatRows,
      rowsById = instance.rowsById,
      allColumns = instance.allColumns,
      userFilterTypes = instance.filterTypes,
      globalFilter = instance.globalFilter,
      manualGlobalFilter = instance.manualGlobalFilter,
      globalFilterValue = instance.state.globalFilter,
      dispatch = instance.dispatch,
      _instance$autoResetGl = instance.autoResetGlobalFilter,
      autoResetGlobalFilter = _instance$autoResetGl === void 0 ? true : _instance$autoResetGl,
      disableGlobalFilter = instance.disableGlobalFilter;
  var setGlobalFilter = React.useCallback(function (filterValue) {
    dispatch({
      type: actions.setGlobalFilter,
      filterValue: filterValue
    });
  }, [dispatch]); // TODO: Create a filter cache for incremental high speed multi-filtering
  // This gets pretty complicated pretty fast, since you have to maintain a
  // cache for each row group (top-level rows, and each row's recursive subrows)
  // This would make multi-filtering a lot faster though. Too far?

  var _React$useMemo = React.useMemo(function () {
    if (manualGlobalFilter || typeof globalFilterValue === 'undefined') {
      return [rows, flatRows, rowsById];
    }

    var filteredFlatRows = [];
    var filteredRowsById = {};
    var filterMethod = getFilterMethod(globalFilter, userFilterTypes || {}, filterTypes);

    if (!filterMethod) {
      console.warn("Could not find a valid 'globalFilter' option.");
      return rows;
    }

    allColumns.forEach(function (column) {
      var columnDisableGlobalFilter = column.disableGlobalFilter;
      column.canFilter = getFirstDefined(columnDisableGlobalFilter === true ? false : undefined, disableGlobalFilter === true ? false : undefined, true);
    });
    var filterableColumns = allColumns.filter(function (c) {
      return c.canFilter === true;
    }); // Filters top level and nested rows

    // Filters top level and nested rows
    var filterRows = function filterRows(filteredRows) {
      filteredRows = filterMethod(filteredRows, filterableColumns.map(function (d) {
        return d.id;
      }), globalFilterValue);
      filteredRows.forEach(function (row) {
        filteredFlatRows.push(row);
        filteredRowsById[row.id] = row;
        row.subRows = row.subRows && row.subRows.length ? filterRows(row.subRows) : row.subRows;
      });
      return filteredRows;
    };

    return [filterRows(rows), filteredFlatRows, filteredRowsById];
  }, [manualGlobalFilter, globalFilterValue, globalFilter, userFilterTypes, allColumns, rows, flatRows, rowsById, disableGlobalFilter]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 3),
      globalFilteredRows = _React$useMemo2[0],
      globalFilteredFlatRows = _React$useMemo2[1],
      globalFilteredRowsById = _React$useMemo2[2];

  var getAutoResetGlobalFilter = useGetLatest(autoResetGlobalFilter);
  useMountedLayoutEffect(function () {
    if (getAutoResetGlobalFilter()) {
      dispatch({
        type: actions.resetGlobalFilter
      });
    }
  }, [dispatch, manualGlobalFilter ? null : data]);
  Object.assign(instance, {
    preGlobalFilteredRows: rows,
    preGlobalFilteredFlatRows: flatRows,
    preGlobalFilteredRowsById: rowsById,
    globalFilteredRows: globalFilteredRows,
    globalFilteredFlatRows: globalFilteredFlatRows,
    globalFilteredRowsById: globalFilteredRowsById,
    rows: globalFilteredRows,
    flatRows: globalFilteredFlatRows,
    rowsById: globalFilteredRowsById,
    setGlobalFilter: setGlobalFilter,
    disableGlobalFilter: disableGlobalFilter
  });
}